import { isScreenshareFeed, pauseVideoStreams } from 'features/layout/pagination/mediaUpdates';
import { SubscriberMid } from 'features/streaming/types';
import { call } from 'redux-saga/effects';
import { RTCClient } from 'utils/webrtc';
import type { StreamMedia } from 'utils/webrtc/receiving/StreamMedia';

export function* pauseVideoSaga(mid: SubscriberMid) {
  const feedId = RTCClient.receivingFeed.feedIdByMid[mid];

  if (feedId === undefined || isScreenshareFeed(feedId)) {
    return;
  }

  const videoStream: StreamMedia | undefined = RTCClient.receivingFeed.media.peekSubscriberStream(
    feedId,
    mid
  );

  if (videoStream) {
    yield call(pauseVideoStreams, [videoStream]);
  }
}
